import { getLanguageForStudent } from '../../store/selectors/sharedSelectors'

import { values } from '../../utility/functions'

import { AVAILABLE_LANGUAGES } from '@mission.io/mission-toolkit/constants'

import classnames from 'classnames'
import capitalize from 'lodash/capitalize'
import React from 'react'
import { useSelector } from 'react-redux'

/**
 * LanguageSelector - allows the user to select one of the available languages for a student
 *
 * @param {Object} props - the react props
 * @param {(language: string) => any} props.onSelect - a callback for when a user selects a new language for the given student
 * @param {string} props.className? - the className to apply to the select tag
 *
 * @return {React$Node}
 */
export function LanguageSelector({
	studentId,
	onSelect,
	className,
	selectorId,
}: {
	studentId: string,
	onSelect: (language: string) => any,
	className?: string,
	selectorId?: string,
}): React$Node {
	const currentLanguage = useSelector(state => getLanguageForStudent(state, studentId))

	return (
		<select
			className={classnames('text-white bg-game-primary-500 w-full rounded', className)}
			value={currentLanguage}
			onChange={e => {
				if (e.target.value === currentLanguage) {
					return
				}
				onSelect(e.target.value)
			}}
			name="select language"
			id={selectorId}>
			{values(AVAILABLE_LANGUAGES).map(language => (
				<option value={language} key={language}>
					{language === AVAILABLE_LANGUAGES.ENGLISH ? 'None (English)' : capitalize(language)}
				</option>
			))}
		</select>
	)
}
